<template>
  <div class="header">
    <div class="app-control">
      <div class="switch-btn" @click="switchSidebar"><span></span></div>
      <div class="right-region" v-if="$store.state.userInfo">
        <div class="current-project app-control">
          <p>{{currentProject}}</p>
          <el-dropdown placement="bottom" @command="switchProject">
            <i class="el-icon-sort"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{id: value.project_id}" v-for="(value, index) in projectOptions" :key="index">{{value.attr_data.project_attr_name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-dropdown placement="bottom" @command="handleCommand">
          <span class="color-primary">{{$store.state.userInfo.account_attr_data.account_attr_phone}}<i class="el-icon-arrow-down"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{type: 'logout'}">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import EntranceService from '@/io/entrance.js';
  
  export default {
    name: 'Header',
    data() {
      return {
        currentProject: '',
        projectOptions: [],
        name: ''
      }
    },
    watch: {
      '$store.state.isLogin': {
        handler(newValue, oldValue) {
          if (newValue) {
            CommonService.userProjectList().then(res => {
              res.data.forEach(val => {
                if (val.is_now) {
                  this.currentProject = val.attr_data.project_attr_name;
                }
              });
              this.projectOptions = res.data;
            }).catch(() => {});
          }
        },
        immediate: true
      }
    },
    methods: {
      switchSidebar() {
        this.$store.commit('setSidebarCollapse', !this.$store.state.sidebarCollapse);
      },
      handleCommand(command) {
        if (command.type === 'logout') {
          EntranceService.logout().then(() => {
            this.$store.commit('setIsLogin', false);
            this.$router.replace({
              path: '/entrance'
            });
          }).catch(() => {});
        }
      },
      switchProject(command) {
        CommonService.switchProject(command.id).then(res => {
          window.location.reload();
        }).catch(() => {})
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .header {
    background-color: @color-white;
    .app-control {
      height: 100%;
      padding: 0 @distance;
    }
    .switch-btn {
      width: 24px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      transition: all @time;
      &:hover {
        &::before,
        &::after {
          width: 100%;
        }
      }
      &::before,
      &::after {
        content: '';
        position: absolute;
        right: 0;
        height: 2px;
        background-color: @color-primary;
        transition: all @time;
      }
      &::before {
        width: 60%;
        top: 0;
      }
      &::after {
        width: 80%;
        bottom: 0;
      }
      span {
        width: 100%;
        height: 2px;
        background-color: @color-primary;
      }
    }
  }
</style>